import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import MuiButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';

import DocumentsSignDialog from 'components/common/DocumentsSignDialog';

import hexToRgb from 'styles/hexToRgb';

const styles = theme => ({
  container: {
    position: 'absolute',
  },
  root: {  
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    backgroundColor: `rgba(${hexToRgb(theme.palette.grey[900])}, 0.05)`,
  },
  label: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    fontStyle: 'italic',
  },
});

class DocumentPreviewFillSignatureField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signDialogOpen: false,
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onSignDialogClose = this.onSignDialogClose.bind(this);
  }

  onButtonClick() {
    this.setState({ signDialogOpen: true });
  }

  onSignDialogClose() {
    this.setState({ signDialogOpen: false });
  }

  render() {
    const {
      input, x, y, width, height, documentWidth, documentPrintWidth, documentPrintHeight, fieldsShift, classes,
    } = this.props;
    const { signDialogOpen } = this.state;
    return (
      <div
        className={classes.container}
        style={{
          left: `${((x + fieldsShift.x) / documentPrintWidth) * 100}%`,
          top: `${((y + fieldsShift.y) / documentPrintHeight) * 100}%`,
          ...width ? { width: `${((width / documentPrintWidth) * 100)}%` } : {},
          ...height ? { height: `${(height / documentPrintHeight) * 100}%` } : {},
        }}
      >
        <MuiButtonBase
          onClick={this.onButtonClick}
          className={classes.root}
          style={{
            ...input.value && input.value.length > 0 ? {
              backgroundImage: `url(${input.value})`,
            } : {},
          }}
        />
        {(input.value && input.value.length > 0) &&
          <Typography
            className={classes.label}
            style={{
              fontSize: (7 / 2.834646) * (documentWidth / documentPrintWidth),
            }}
          >
            Signed electronically
          </Typography>
        }
        <DocumentsSignDialog
          open={signDialogOpen}
          initialValues={{
            signature: input.value,
          }}
          onClose={this.onSignDialogClose}
          onSubmitSuccess={(values) => {
            input.onChange(values.signature);
            this.onSignDialogClose();
          }}
        />
      </div>
    );
  }
}

DocumentPreviewFillSignatureField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
  }).isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  documentPrintWidth: PropTypes.number.isRequired,
  documentPrintHeight: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(DocumentPreviewFillSignatureField);



// WEBPACK FOOTER //
// ./src/components/common/DocumentPreviewFillForm/DocumentPreviewFillSignatureField.js